import type { RouteObject } from 'react-router';

/**
 * `/import` (020 US2, spec §Assumptions: "a dedicated page rather than inline in existing views").
 * One lazy chunk holding one screen, reached from the settings surface like `/feeds` — an import is
 * a maintenance surface, not one of the sidebar's data screens.
 */
export const routes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import('./import-page')).default }) },
];
